
import React from "react";
import Vector from "../../../assets/Vector.png";
import Checkmark from "../../../assets/checkmark.png";
import "./ClothingColorBlocks.css";

export const ClothingColorBlocks = ({
  colors,
  selectedColors,
  onToggle,
  testId,
}) => (
  <div className="colorBlocksContainer">
    {colors.map((color, index) => {
      const isSelected = selectedColors.some((c) => c.hex === color.hex);
      return (
        <div
          key={index}
          onClick={() => onToggle(color)}
          data-testid={testId}
          className={`colorBlock ${color.name === "White" ? "whiteBlock" : ""}`}
          style={{ backgroundColor: color.hex }}
        >
          {isSelected && (
            <div
              className={`colorBlockCheck ${color.name === "White" ? "whiteCheck" : ""}`}
              style={{
                backgroundImage: `url(${color.name === "White" ? Checkmark : Vector})`,
              }}
            />
          )}
        </div>
      );
    })}
  </div>
);
